export default "/images/icon-ai-success.svg?f9126a93ae6143e5f494bc5968c9ce04";